/*** IMPORTS FROM imports-loader ***/
var define = false;

/* global Foundation */

import $ from 'jquery'
import Promise from 'es6-promise'
import { destroyVideos, setupVideos } from './_video'

const $body = $(document.body)

function setupModal($modal) {
  if (!$modal.length) {
    return
  }

  if ($modal.data('zfPlugin')) {
    return $modal.data('zfPlugin')
  }

  $modal
    .off('open.zf.reveal.app')
    .off('closed.zf.reveal.app')
    .on('open.zf.reveal.app', () => {
      setupVideos($modal[0], true, true)
      $body.addClass('blurred')
    })
    .on('closed.zf.reveal.app', () => {
      destroyVideos($modal)
      $body.removeClass('blurred')
    })

  return new Foundation.Reveal($modal, { vOffset: 40 })
}

function setupModals(container) {
  $(container).find('a[href^="#modal-"]').each((idx, anchor) => {
    const $anchor = $(anchor)
    const $modal = $($anchor.attr('href'))

    $anchor.on('click', (ev) => {
      ev.preventDefault()
      ev.stopPropagation()
    })

    const modal = setupModal($modal)
    if (modal) {
      $anchor.on('click', () => {
        modal.open()
      })
    }
  })
}

function destroyModals(container) {
  const promises = []

  $(container).find('a[href^="#modal-"]').each((idx, anchor) => {
    const $anchor = $(anchor)
    const $modal = $($anchor.attr('href'))

    if (!$modal.length) {
      return
    }

    promises.push(new Promise((resolve) => {
      if ($modal.data('zfPlugin')) {
        $modal.on('closed.zf.reveal', () => {
          $modal.foundation('destroy')
          $modal.remove()
          resolve()
        })
        $modal.trigger('closed.zf.reveal')
      } else {
        resolve()
      }
    }))
  })

  return promises
}

export { setupModal, setupModals, destroyModals }

